import React, { useEffect,useRef, useState } from "react";
import { dropTargetForElements } from "@atlaskit/pragmatic-drag-and-drop/element/adapter";

import styles from "./BoardAvailableSlot.module.css";

export const BoardAvailableSlot = ({
  item,
  doctor,
  onAddConsultation,
  slotDurationMinutes,
}) => {
  const elementRef = useRef(null);
  const [isDropTarget, setIsDropTarget] = useState(false);
  const [isDraggedOver, setIsDraggedOver] = useState(false);

  useEffect(() => {

    if (!item || !doctor) {
      return;
    }

    const element = elementRef.current;
    if (!element) return;

    let cleanup;
    try {
      cleanup = dropTargetForElements({
        element,
        getData: () => ({ item, doctor, type: "available-slot" }),
        canDrop: ({ source }) => {

          return source.data.type === "appointment";
        },
        onDragEnter: () => {
          setIsDropTarget(true);
          setIsDraggedOver(true);
        },
        onDragLeave: () => {
          setIsDropTarget(false);
          setIsDraggedOver(false);
        },
        onDrop: () => {
          setIsDropTarget(false);
          setIsDraggedOver(false);
        },
      });
    } catch (error) {
      console.warn("Failed to setup drop target:", error);
      return;
    }

    return () => {
      if (typeof cleanup === "function") {
        try {
          cleanup();
        } catch (error) {
          console.warn("Failed to cleanup drop target:", error);
        }
      }
    };
  }, [item, doctor]);

  if (!item || !doctor) {
    return null;
  }

  return (
    <button
      ref={elementRef}
      className={`${styles.availableSlot} ${
        isDropTarget ? styles.dropTarget : ""
      } ${isDraggedOver ? styles.draggedOver : ""}`}
      style={{
        height: slotDurationMinutes === 5 ? "45px" : "60px",
      }}
      onClick={onAddConsultation}
      aria-label="add consultation"
    >
      <div className={styles.slotContent}>
        {isDraggedOver ? (
          <div className={styles.dropLabel}>
            <span className={styles.dropText}>Move here</span>
          </div>
        ) : (
          <div className={styles.addLabel}>
            <span className={styles.addIcon}>+</span>
            <span className={styles.addText}>Add</span>
          </div>
        )}
      </div>
    </button>
  );
};
